export const SEND_SMS_API = '/trigger/campaign-url'
